import Notification from './notification';

export default Notification;
